@if (!embedded()) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button
          defaultHref="settings"
          mode="md"
        ></ion-back-button>
      </ion-buttons>
      <ion-title
        role="heading"
        aria-level="1"
        mode="md"
      >
        {{ 'page.settings.profile' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ion-content>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div class="app__content profile">
    <app-loader
      [loading]="true"
      [hidden]="!loading"
    ></app-loader>
    <div
      class="profile__content"
      [hidden]="loading"
      [class.logged-in]="user()"
    >
      @if (user()) {
        <p>
          <span
            aria-hidden="true"
            inlineSVG="assets/icons/mail.svg"
          ></span>
          @if (!loading) {
            {{ user().email }}
          }
        </p>
        <div class="profile__content__buttons">
          <ion-button
            expand="block"
            (click)="logout()"
            [disabled]="loading"
          >
            {{ 'page.settings.profile.logout' | translate }}
          </ion-button>
          <ion-button
            class="remove"
            (click)="remove()"
            fill="clear"
            color="danger"
          >
            {{ 'page.settings.profile.remove' | translate }}
          </ion-button>
          <ion-button
            class="actions"
            color="dark"
            id="profile-actions-trigger"
            fill="clear"
            [attr.aria-label]="'page.settings.profile.more-actions' | translate"
          >
            <ion-icon
              aria-hidden="true"
              slot="icon-only"
              [icon]="'ellipsis-vertical'"
            ></ion-icon>
          </ion-button>

          <ion-popover
            #actionsPopover
            trigger="profile-actions-trigger"
            reference="trigger"
            side="bottom"
            alignment="center"
          >
            <ng-template>
              <ion-button
                fill="clear"
                color="danger"
                (click)="actionsPopover.dismiss(); remove()"
              >
                {{ 'page.settings.profile.remove' | translate }}
              </ion-button>
            </ng-template>
          </ion-popover>
        </div>
      } @else {
        <p>{{ 'page.settings.profile.desc' | translate }}</p>
        <div class="profile__content__buttons">
          <ion-button
            routerLink="/login"
            expand="block"
          >
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="assets/icons/mail.svg"
            ></ion-icon>
            {{ 'page.settings.profile.login.email' | translate }}
          </ion-button>
        </div>
      }
    </div>
  </div>
</ng-template>
